import { useState, useEffect } from 'react'

import RatingTable from '../star-rating/rating-table/rating-table'
import OriginLink from 'components/parts/originLink/originLink'

import { Pathname } from 'constants/data'
import { getAxiosSingle } from 'pages/api/axios'
import { originRaiting } from 'utils/analytics/webinars/webinat_active'
import { IObj } from 'constants/types/common.types'
import { URL_LIST } from 'constants/url'

import styles from './webinar-active-end-advertising.module.scss'
import Button from 'components/parts/button/button'

const WebinarActiveEndAdvertising = ({ webinarId }: { webinarId: number }) => {
  const [rating, setRating] = useState({ relevance: 0 })
  const [isRatingLoaded, setLoaded] = useState(false)

  const getRatingData = async () => {
    const data = (await getAxiosSingle(`${URL_LIST.RATE}?id=${webinarId}`)) as IObj<any>
    setLoaded(true)
    if (data) {
      setRating({ ...rating, ...data })
    }
  }

  useEffect(() => {
    getRatingData()
  }, [])

  return (
    <div className={styles.content}>
      <h3 className={styles.title}>
        Вебинар окончен.
        <br />
        Приглашаем на курс "Современная гериатрия для практикующих врачей".
      </h3>
      <div className={styles.buttonWrapper}>
        <OriginLink href={`/${Pathname.NMO_COURSE_GERIATRICS}`} className={styles.link}>
          <Button>Узнать подробнее</Button>
        </OriginLink>
      </div>
      {isRatingLoaded && !rating.relevance && (
        <RatingTable isPast webinarId={webinarId} origin={originRaiting.ACTIVEEND} />
      )}
    </div>
  )
}
export default WebinarActiveEndAdvertising
